<template>
  <v-card
    class="pa-0 d-flex flex-column align-center cursor-pointer py-2 px-3 option-card card card-hover"
    elevation="0"
    height="248px"
    outlined
    width="200px"
    :data-tourid="tourId"
    @click="$emit('click')"
  >
    <v-card-title
      class="ma-0 pa-0 text-center mb-2"
      data-testid="optionCard-title"
      style="min-height: 48px;"
    >
      <p
        v-snip="2"
        class="ma-0 pa-0 blue-grey--text text--darken-3 body-1 font-weight-600 break-word text-center"
      >
        {{ title }}
      </p>
    </v-card-title>

    <v-card-text
      class="d-flex flex-column align-center ma-0 pa-0"
      data-testid="optionCard-content"
    >
      <div
        class="d-flex align-center justify-center icon-container mb-4"
        data-testid="optionCard-icon"
      >
        <v-icon color="blue" style="transition: none;">{{ icon }}</v-icon>
      </div>

      <p
        class="ma-0 pa-0 caption text-center blue-grey--text text--darken-1 break-word"
      >
        {{ description }}
      </p>
    </v-card-text>

    <v-card-actions
      class="ma-0 mt-auto pa-0 pb-2"
      data-testid="optionCard-start-button"
    >
      <Button color="primary" data-testid="optionCard-button-start" plain :text="ctaText" />
    </v-card-actions>
  </v-card>
</template>

<script>
import Button from '@/components/UI/Button.vue'

export default {
  name: 'OptionCardForModal',

  props: {
    tourId: String,
    icon: {
      type: String,
    },
    description: {
      type: String,
    },
    title: {
      type: String,
    },
    type: {
      type: String,
    },
    buttonText: String,
  },

  components: {
    Button,
  },

  computed: {
    ctaText() {
      return this.buttonText || this.$t('common.button.start')
    },
  },
}
</script>
<style lang="scss" scoped>
.icon-container {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background: $color-blue-lighten2;
}

.card {
  &:hover {
    .icon-container {
      background: $color-blue !important;
    }
    .v-icon {
      color: white !important;
    }
  }
}
</style>
